
<app-strain-select-multiple [hidden]="hidden" [(strainIds)]="strainIds" [(strains)]="allStrains"></app-strain-select-multiple>